import $ from 'jquery';

import plugin from './plugin';
import debounce from "debounce";

class Search {

	constructor(element, options) {
		const $form = this.$form = $(element);
		const $input = this.$input = $form.find('input[name=query]');
		const $button = this.$button = $form.find('button');
		this.$resultsContainer = $('.search .search-results-container');
		this.$results = $('.search .search-results');
		this.$items = []; // actual result rows
		this.$active = null;
		this.activeIndex = null;

		let lastVal = null;

		$button.on('click', e => {
			e.preventDefault();
			if ($input.val().trim() === '') {
				$input.focus();
			} else {
				$form.trigger('submit');
			}
		});

		$form.on('submit', e => {
			e.preventDefault();

			const val = $input.val().trim();
			if (val === lastVal) {
				e.stopImmediatePropagation();
				return;
			}
			lastVal = val;
			$.nette.ajax($form.data('ajaxaction'), $form, e);
		});

		$input.on('search', e => {
			const val = e.target.value;
			if (!val) {
				this.close();
			}
		});

		$input[0].addEventListener('keydown', e => {
			if ([13, 27, 38, 40].indexOf(e.keyCode) === -1) {
				debounce(() => this.keydown(e), 200)();
			} else {
				this.keydown(e);
			}
		});

		// close by clicking outside
		$(document).click(e => {
			const $target = $(e.target);
			if (!$target.closest('.search-results-container').length) {
				this.close();
			}
		});
	}

	dataLoaded() {
		this.$items = this.$results.find('.search-result');

		if (this.$items.length === 0) {
			this.$results.addClass('no-results');
		} else {
			this.$results.removeClass('no-results');
		}
		this.$resultsContainer.show();

		this.$items.on('mouseover', e => this.mouseover(e));
		this.activeIndex = null;
		this.$active = null;
	}

	setActive(index) {
		if (this.activeIndex === index) return;
		this.activeIndex = index;
		this.$active = this.$items.eq(index);
		this.$items.removeClass('active');
		this.$active.addClass('active');
	}

	moveActive(diff) {
		if (!this.$items.length) return;

		let index = this.activeIndex;

		if (index === null) {
			index = diff > 0 ? 0 : this.$items.length - 1;
		} else {
			index += diff;
		}
		if (index >= this.$items.length) {
			index = 0;
		} else if (index < 0) {
			index = this.$items.length - 1;
		}
		this.setActive(index);
	}

	keydown(e) {
		switch (e.keyCode) {
			case 13:
				if (this.$active) {
					window.location.href = this.$active.attr('href');
				}
				break;
			case 27:
				this.close();
				break;
			case 40: // down arrow
				this.moveActive(1);
				break;
			case 38: // up arrow
				this.moveActive(-1);
				break;
			default:
				var val = this.$input.val();
				if (val.trim() === '') {
					this.close();
				} else {
					this.$form.trigger('submit');
				}
		}
	}

	mouseover(e) {
		const $item = $(e.target);
		if (!$item.hasClass('search-result')) return;
		const index = this.$items.index($item);
		this.setActive(index);
	}

	close() {
		this.$results.html('');
		this.$resultsContainer.hide();
		this.$input.val('');
	}

}

plugin('Search', Search);

